import { AudioComponentSelector, VideoComponentSelector } from '@pm2/media-component';

const PDF_STYLESHEET = `
  @media screen, print {
    html, body {
      position: static !important;
      height: auto !important;
      overflow: visible !important;

      background: #fff !important;
      opacity: 1 !important;

      box-sizing: content-box !important;
      margin: 0 !important;
      padding: 0 !important;
      min-height: 0 !important;

      font-family: Georgia, 'Times New Roman', Times, serif !important;
      font-size: 16px !important;
      line-height: 1.875 !important;
      color: #000 !important;
    }

    body {
      padding: 0 50px !important;
    }

    .gComponentToolbar {
      display: none !important;
    }

    * {
      transition: none !important;
      animation: none !important;
    }

    article.gPortal-page {
      position: relative;

      box-sizing: border-box;
      overflow: hidden;
      width: 100%;
      max-width: none;
      padding: 0;
      margin: 0;

      font-family: Georgia, 'Times New Roman', Times, serif !important;
      font-size: 16px !important;

      column-fill: auto;
      page-break-after: always;

      counter-reset: glossary-words;
    }

    article.gPortal-page::before,
    article.gPortal-page::after {
      display: none !important;
    }

    article mark {
      background: transparent !important;
    }

    html.richText article {
      overflow: visible;
    }

    .line-gutter {
      position: absolute;
      top: 0;
      right: calc(100% + 12px);
      color: #000;
      font-size: 11px !important;
      line-height: 18px !important;
    }

    header {
      overflow: hidden;
      padding-bottom: 30px;
    }

    footer {
      position: relative;
      overflow: hidden;
      width: 100%;

      box-sizing: border-box;
      padding-top: 30px;

      column-fill: auto;
      counter-reset: glossary-words;

      font: 12px/1.5 Georgia, 'Times New Roman', Times, serif;
      color: #000;
    }

    footer::before {
      content: "";
      display: block;

      position: absolute;
      top: 0;
      left: 0;

      width: 33.33%;
      height: 2px;
      background: currentColor;

      -webkit-print-color-adjust: exact;
    }

    p {
      margin: 30px 0;
    }

    a {
      color: inherit;
      text-decoration: none;
    }

    h1:first-child,
    h2:first-child,
    h3:first-child,
    h4:first-child,
    h5:first-child,
    h6:first-child,
    p:first-child {
      margin-top: 0;
    }

    h1:last-child,
    h2:last-child,
    h3:last-child,
    h4:last-child,
    h5:last-child,
    h6:last-child,
    p:last-child {
      margin-bottom: 0;
    }

    [data-content-component="true"] {
      page-break-inside: avoid;
    }

    [data-component-type="${AudioComponentSelector}"],
    [data-component-type="${VideoComponentSelector}"] {
      display: none;
    }

    .gGlossaryWord__word {
      counter-increment: glossary-words;

      position: relative;
      color: inherit !important;
    }

    .gGlossaryWord__word > sup {
      font-size: 11px;

      /**
       * hardcoded alignment of superscript, to avoid interference with the
       * spacing between lines
       */
      vertical-align: baseline;
      position: relative;
      top: -6px;
    }

    .gGlossaryWord__word > sup::before {
      content: counter(glossary-words);
    }

    .gGlossaryWord__pdfDefinition {
      margin-bottom: 12px;
    }

    .gGlossaryWord__pdfDefinition > b:first-child > sup {
      display: inline-block;
      margin-right: 2px;
    }

    .gGlossaryWord__definition {
      display: none;
    }
  }
`;
const PDF_RICHTEXT_STYLESHEET = `
  @media screen, print {
    html, body, article.gPortal-page {
      font-family: [FONT] !important;
    }
  }
`;

export { PDF_RICHTEXT_STYLESHEET, PDF_STYLESHEET };
//# sourceMappingURL=pdfStyleSheet.js.map
